import { render, staticRenderFns } from "./TopicShare.vue?vue&type=template&id=8cf2c00e&scoped=true&lang=html&"
import script from "./TopicShare.vue?vue&type=script&lang=js&"
export * from "./TopicShare.vue?vue&type=script&lang=js&"
import style0 from "./TopicShare.vue?vue&type=style&index=0&id=8cf2c00e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf2c00e",
  null
  
)

export default component.exports